import { ReactNode } from 'react';
import styled, { CSSProperties } from 'styled-components';

import { useBranding } from '~src/context/BrandingContext';

const StyledTab = styled.div<{ isActive?: boolean; background: CSSProperties['background'] }>(
  ({ isActive = false, background }) => ({
    background,
    padding: '8px 8px 8px',
    borderRadius: '10px 10px 0 0',
    cursor: isActive ? 'default' : 'pointer',
  })
);

type TabProps = {
  isActive?: boolean;
  onClick: () => void;
  children: ReactNode;
};

export const Tab = ({ isActive = false, onClick, children }: TabProps) => {
  const { lightColor, darkColor } = useBranding();

  return (
    <StyledTab onClick={onClick} background={isActive ? lightColor : darkColor}>
      {children}
    </StyledTab>
  );
};
